import { createContext, useMemo } from 'react';

import { AuthModal, HowToEarnPointsModal, ProfilePublicityModal, AchievementModal } from '../../components/modals';

import { useAchivementModal, useAuthModal, useHowToEarnPointsModal, useProfilePublicityModal } from './hooks';
import { ModalContextValue, ModalProviderProps } from './ModalContext.types';

export const ModalContext = createContext<ModalContextValue | undefined>(undefined);

export const ModalProvider = ({ children }: ModalProviderProps) => {
    // Модальное окно авторизации
    const { authModalOptions, ...authModal } = useAuthModal();

    // Модальное окно "Как повысить рейтинг"
    const howToEarnPointsModal = useHowToEarnPointsModal();

    // Модальное окно для ачивок
    const { achievementId, ...achievementModal } = useAchivementModal();

    // Модальное окно "Публичность профиля"
    const profilePublicityModal = useProfilePublicityModal();

    const value: ModalContextValue = useMemo(
        () => ({
            auth: authModal,
            howToEarnPoints: howToEarnPointsModal,
            achievement: achievementModal,
            profilePublicity: profilePublicityModal,
        }),
        [authModal, howToEarnPointsModal, achievementModal, profilePublicityModal],
    );

    return (
        <ModalContext.Provider value={value}>
            {children}

            <AuthModal
                retpath={authModalOptions.retpath}
                isOpen={authModal.isOpen}
                onClose={value.auth.close}
                onCloseFunction={authModalOptions.onClose}
            />

            <HowToEarnPointsModal isOpen={howToEarnPointsModal.isOpen} onClose={value.howToEarnPoints.close} />
            <AchievementModal
                isOpen={achievementModal.isOpen}
                onClose={value.achievement.close}
                achievementId={achievementId}
            />

            <ProfilePublicityModal isOpen={profilePublicityModal.isOpen} onClose={value.profilePublicity.close} />
        </ModalContext.Provider>
    );
};
